module.exports = __webpack_public_path__ + "static/assets/be4e2bf9b94856d02aa68ae48fc7064c.png";